module.exports = __webpack_public_path__ + "img/13.b919b8be.png";